import { createSlice } from '@reduxjs/toolkit';
import { ActionType } from '../models/action-type';

export type RecaptchaSliceState = {
  needV2: boolean;
};

const initialState: RecaptchaSliceState = {
  needV2: false,
};

const setNeedV2: ActionType<RecaptchaSliceState, boolean> = (state, action) => {
  state.needV2 = action.payload;
};

export const recaptchaSlice = createSlice({
  name: 'recaptcha',
  initialState,
  reducers: {
    setNeedV2,
  },
});

export const recaptchaActions = recaptchaSlice.actions;
export const recaptchaReducer = recaptchaSlice.reducer;
